<template>
	<b-card class="sa-card" header="Task" header-tag="header" footer-tag="footer" title="">
		<b-row>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Codice:</label>
				<span>{{ jsonData.codiceTask }}</span>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Attivita:</label>
				<router-link class="sa-edit-link" :to="'/gestioneattivita/attivita/dettaglio/' + jsonData.idAttivita"
					><span>{{ jsonData.nomeAttivita }}</span></router-link
				>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Nome:</label>
				<span>{{ jsonData.nome }}</span>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Priorità:</label>
				<priorita-colors :prioritaLabel="jsonData.descrizionePriorita"></priorita-colors>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data Inizio Programmata:</label>
				<span>{{ formatDate(jsonData.dataInizioProgrammata) }}</span>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data Fine Programmata:</label>
				<span>{{ formatDate(jsonData.dataFineProgrammata) }}</span>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data Inizio Effettiva:</label>
				<span>{{ formatDate(jsonData.dataOraInizio) }}</span>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Data Fine Effettiva:</label>
				<span>{{ formatDate(jsonData.dataOraFine) }}</span>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Tempo Stimato (in Ore):</label>
				<span>{{ jsonData.tempoStimato }}</span>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Tempo Effettivo (in Ore):</label>
				<span>{{ jsonData.tempoEffettivo }}</span>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Stato Attuale:</label>
				<stati-colors :statoLabel="jsonData.statoAttuale"></stati-colors>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="3" lg="3" xl="3">
				<label class="sa-label-data">Stato Data/Ora:</label>
				<span>{{ formatDateTime(jsonData.statoAttualeDataOra) }}</span>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Descrizione:</label>
				<span>{{ jsonData.descrizione }}</span>
			</b-col>
			<b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
				<label class="sa-label-data">Note:</label>
				<span>{{ jsonData.note }}</span>
			</b-col>
		</b-row>
	</b-card>
</template>

<script>
import UtilityMixin from "../../utility/UtilityMixin";
import PrioritaColors from "../utility/PrioritaColors.vue";
import StatiColors from "../utility/StatiColors.vue";
export default {
	mixins: [UtilityMixin],
	components: { PrioritaColors, StatiColors },
	data() {
		return {
			id: null,
			pathResource: "/gestioneattivitatasks",
			tipoAttivitaOptions: [],
			jsonData: { descrizione: "", attivita: null, dataOraInizio: null, dataOraFine: null, statoAttuale: "", priorita: "" },
		};
	},
	mounted() {
		this.id = this.$route.params.id;
		if (this.id !== "-1") {
			this.loadData();
		}
	},
	watch: {
		jsonData: {
			handler(jsonData) {
				this.$emit("updateJsonData", jsonData);
			},
			deep: true,
		},
	},
	methods: {
		loadData() {
			let me = this;
			me.$emit("beforeLoadData");
			UtilityMixin.methods.loadDataResources(me.pathResource + "/" + me.id, {}, me.loadDataSuccess, me.loadDataError);
		},
		loadDataSuccess(response) {
			let me = this;
			me.jsonData = response.data.data;
			me.$emit("afterLoadData");
		},
		loadDataError(error) {
			let me = this;
			console.log(error);
			me.$emit("afterLoadData");
		},
	},
};
</script>

<style></style>
